import { getService } from 'data/function';
import { EventAction } from '../EventAction';
import { applicationListStateName } from 'modules/application/list';
import { selectWhichCreationRouteToRedirect } from 'modules/application/create/steps/aiAgent';
export class RedirectProcessor {
    static get $state() {
        return getService('$state');
    }
    static get UsersService() {
        return getService('UsersService');
    }
    /**
     * Process command from postMessage event
     * @param payload
     */
    static process({ message, source }) {
        const action = message.content.action;
        switch (action) {
            case EventAction.RedirectToApplicationList:
                RedirectProcessor.redirectToApplicationList();
                source.postMessage(true, '*');
                break;
            case EventAction.RedirectToCreateAiAgent:
                RedirectProcessor.redirectToCreateAiAgent();
                source.postMessage(true, '*');
                break;
            case EventAction.RedirectToApplicationDetail:
                const { shortName } = message.content;
                RedirectProcessor.redirectToApplicationDetail(shortName);
                source.postMessage(true, '*');
                break;
            case EventAction.RedirectToUserHistory:
                const { customerIdentity, ticketId } = message.content;
                RedirectProcessor.redirectToUserHistory(customerIdentity, ticketId);
                source.postMessage(true, '*');
                break;
            case EventAction.RedirectToJourney:
                RedirectProcessor.redirectToJourney(message.content?.marketingFunnelId, message.content?.goTo);
                source.postMessage(true, '*');
                break;
            default:
                throw new Error('Unrecognized RedirectProcessor action');
        }
    }
    static redirectToApplicationList() {
        RedirectProcessor.$state.go(applicationListStateName);
    }
    static async redirectToCreateAiAgent() {
        const pathToRedirect = await selectWhichCreationRouteToRedirect();
        RedirectProcessor.$state.go(pathToRedirect);
    }
    static async redirectToApplicationDetail(shortName) {
        RedirectProcessor.$state.go('auth.application.detail.aiAgents.home', {
            shortName,
        });
    }
    static async redirectToUserHistory(customerIdentity, ticketId) {
        const url = RedirectProcessor.$state.href('auth.application.detail.attendance.history.detail', {
            id: this.UsersService.getDecodedUserIdentity(customerIdentity),
            ticketId: ticketId,
        });
        window.open(url, '_blank');
    }
    static async redirectToJourney(marketingFunnelId, goTo) {
        RedirectProcessor.$state.go(`auth.application.detail.growth.journey.${goTo}`, {
            id: marketingFunnelId,
        });
    }
}
